module.exports = __webpack_public_path__ + "static/media/check.fd6f7b55.svg";